import {Carousel} from "./carousel.js";
import {ABSHtmlElement} from "../abstract/ABSHtmlElement.js";

export class CarouselItem extends ABSHtmlElement {
    private _index?: number;

    constructor() {
        super();
        $(this).on("dragstart", function () {
            return false;
        });
    }

    public formatText() {
        $(this).addClass('shown');//.classList.add('shown')

        const span = $(this).find("span")[0];
        if (!span) return;
        let chars = span.innerHTML.trim().split('');
        while (span.scrollHeight > span.offsetHeight && chars.length) {
            chars.pop();
            span.innerHTML = chars.join('').trim() + '...';
        }
    }

    public get index() {
        return this._index ?? this.forceUpdateIndex();
    }

    public forceUpdateIndex() {
        return (this._index = Array.prototype.indexOf.call(this.parentNode!.children!, this))
    }

    get width() {
        return $(this).width()!;
    }

    get parent() {
        return this.parentNode as Carousel;
    }

    public updatePosition(scroll: number) {
        const maxAllowedScrollX = this.parent.width - this.width;
        let myScroll = scroll + this.width * this.index;
        // Move element to left if it is too much right
        myScroll -= Math.ceil((myScroll - maxAllowedScrollX) / this.parent.width) * this.parent.width;
        // while (myScroll > maxAllowedScrollX) myScroll -= this.parent.width;
        // this.style.setProperty('transform', `translateX(${myScroll}px)`);
        this.style.setProperty('left', myScroll + "px");
    }

    connectedCallback() {
        const parent = this.parentNode;
        if (!(parent instanceof Carousel)) {
            console.warn("Invalid parent element");
            $(this).remove();
        }
    }
}
